import { Icon } from '@/components/entities/Sprite';

const AgeRestrictionBadge = () => (
  <div className="flex items-center justify-center max-lg:hidden absolute -top-8 left-1/2 -translate-x-1/2 z-20">
    <Icon name="age-registration" className="size-16 text-primary-1" />
    <span className="text-white absolute top-1/2 ml-0.75 left-1/2 -translate-x-1/2 -translate-y-1/2 font-hepta font-extrabold text-[1.25rem] leading-[100%] tracking-[-7%]">
      18+
    </span>
  </div>
);

AgeRestrictionBadge.displayName = 'AgeRestrictionBadge';

export default AgeRestrictionBadge;
